import { get, post } from './node';
import { CLIENT_ID } from '../constants';

export const login = (payload) =>
  post(`/oauth/token`, {
    ...payload,
  });

export const refreshToken = () =>
  post(`/oauth/token`, {
    refreshToken: localStorage.getItem('refreshToken'),
    clientId: CLIENT_ID,
    grantType: 'refresh_token',
  });

export const revokeToken = async (impersonating = false) => {
  return post('/oauth/revoke-token', {
    token: impersonating
      ? localStorage.getItem('impersonationToken')
      : localStorage.getItem('accessToken'),
    clientId: CLIENT_ID,
  });
};

export const tokenIntrospection = async (impersonating = false) => {
  const response = await post('/oauth/introspect', {
    token: impersonating
      ? localStorage.getItem('impersonationToken')
      : localStorage.getItem('accessToken'),
    clientId: CLIENT_ID,
  });
  return Boolean(response);
};

export const forgotPassword = (payload) => {
  return post(`/oauth/forgot-password`, payload);
};

export const activateAccount = (payload) => {
  return post('/oauth/activate-account', payload);
};

export const getOauthInvitedUser = ({ invitationToken }) =>
  get(`/oauth/invited-user?invitationToken=${invitationToken}`);

export const resetPassword = (payload) => {
  return post('/oauth/reset-password', payload);
};
